<template>
  <div class="map-data-view">
    <b-card class="mb-1">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <!-- <div>
          <h4 class="mb-0">عرض جميع بيانات الخريطة</h4>
          <small class="text-muted">عرض جميع المشاريع، مكتبات الخرائط، والنقاط الثابتة على الخريطة</small>
        </div> -->
        <div class="mt-1 text-muted">
          <span v-if="dataStats.projects > 0 || dataStats.mapLibraries > 0 || dataStats.fixedPoints > 0 || dataStats.administrativeBoundaries > 0 || dataStats.vrsCoordinates > 0 || dataStats.jxlCoordinates > 0">
            المشاريع: {{ dataStats.projects }} |
            مكتبات الخرائط: {{ dataStats.mapLibraries }} |
            النقاط الثابتة: {{ dataStats.fixedPoints }} |
            الحدود الإدارية: {{ dataStats.administrativeBoundaries }} |
            إحداثيات VRS: {{ dataStats.vrsCoordinates }} |
            إحداثيات JXL: {{ dataStats.jxlCoordinates }} |
            مضلعات JXL: {{ dataStats.jxlPolygons }}
          </span>
          <span v-else>لم يتم تحميل البيانات بعد</span>
          <div
            v-if="debugInfo"
            class="mt-1 small"
          >
            <strong>معلومات التصحيح:</strong> {{ debugInfo }}
          </div>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <b-form-group
            label="حجم الدفعة"
            class="mr-2 mb-0"
          >
            <b-form-input
              v-model.number="chunkSize"
              type="number"
              min="50"
              max="200"
              style="width: 100px;"
            />
          </b-form-group>
          <b-button
            variant="primary"
            class="mr-50"
            :disabled="loading || mapLoading"
            @click="loadMapData"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            تحديث البيانات
          </b-button>
          <!-- <b-button
            variant="outline-primary"
            class="mr-50"
            @click="addUserLocation"
            :disabled="locationLoading || mapLoading"
          >
            <b-spinner small v-if="locationLoading" class="mr-50" />
            موقعي الحالي
          </b-button> -->
        </div>
      </div>
      <!-- <div class="mt-1 text-muted">
        <span v-if="dataStats.projects > 0 || dataStats.mapLibraries > 0 || dataStats.fixedPoints > 0 || dataStats.vrsCoordinates > 0 || dataStats.jxlCoordinates > 0">
          المشاريع: {{ dataStats.projects }} |
          مكتبات الخرائط: {{ dataStats.mapLibraries }} |
          النقاط الثابتة: {{ dataStats.fixedPoints }} |
          إحداثيات VRS: {{ dataStats.vrsCoordinates }} |
          إحداثيات JXL: {{ dataStats.jxlCoordinates }} |
          مضلعات JXL: {{ dataStats.jxlPolygons }}
        </span>
        <span v-else>لم يتم تحميل البيانات بعد</span>
        <div v-if="debugInfo" class="mt-1 small">
          <strong>معلومات التصحيح:</strong> {{ debugInfo }}
        </div>
      </div> -->
    </b-card>

    <div class="map-container-wrapper mb-1">
      <div
        v-if="mapLoading"
        class="loading-overlay"
      >
        <div class="spinner" />
        <p class="text-center mt-2">
          جاري تحميل الخريطة...
        </p>
      </div>
      <div
        v-if="loading && !mapLoading"
        class="loading-overlay"
      >
        <div class="spinner" />
        <p class="text-center mt-2">
          جاري تحميل البيانات...
        </p>
      </div>
      <div
        ref="esriView"
        class="map-view"
      />
    </div>

    <b-card v-if="error">
      <b-alert
        variant="danger"
        show
      >
        <strong>خطأ:</strong> {{ error }}
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import { loadArcgisModules } from '@/utils/arcgisLoader'
import {
  BCard,
  BButton,
  BSpinner,
  BAlert,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import MapLibrary from '@/api/MapLibrary/MapLibraries'
import geodesiaApi from '@/api/geodesia/geodesia'
import {
  GEODESIA_LAYER_TRUNCATED_MESSAGE,
  createGeodesiaLayerCancelSource,
  getGeodesiaLayerFeatures,
  isGeodesiaLayerRequestCanceled,
  isGeodesiaLayerTruncated,
  unwrapGeodesiaLayerPayload,
} from '@/utils/geodesiaMapLayers'
import {
  DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
  ADMINISTRATIVE_BOUNDARY_TYPES,
  administrativeBoundaryLayerKey,
  administrativeBoundaryLayerId,
  createAdministrativeBoundaryVisibility,
  fetchAdministrativeBoundariesGeoJson,
  isAdministrativeBoundaryLayerKey,
  mapAdministrativeBoundaryItemsToGraphics,
  normalizeAdministrativeBoundaryItems,
  typeFromAdministrativeBoundaryLayerKey,
} from '@/utils/administrativeBoundaries'

const mapLibraryApi = new MapLibrary()

export default {
  name: 'MapDataView',
  components: {
    BCard,
    BButton,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      map: null,
      view: null,
      projectsLayer: null,
      mapLibrariesLayer: null,
      fixedPointsLayer: null,
      administrativeBoundaryLayers: {},
      administrativeBoundariesYear: DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
      vrsCoordinatesLayer: null,
      jxlCoordinatesLayer: null,
      jxlPolygonsLayer: null,
      userLocationLayer: null,
      sketchLayer: null,
      sketch: null,
      arcgisModules: null,
      mapLoading: false,
      loading: false,
      locationLoading: false,
      error: null,
      chunkSize: 100000,
      dataStats: {
        projects: 0,
        mapLibraries: 0,
        fixedPoints: 0,
        administrativeBoundaries: 0,
        vrsCoordinates: 0,
        jxlCoordinates: 0,
        jxlPolygons: 0,
      },
      jxlData: {
        points: [],
        polygons: [],
      },
      currentPolygonGraphic: null,
      debugInfo: null,
      userLocationObtained: false,
      defaultCenter: {
        latitude: 30.0444, // Cairo, Egypt
        longitude: 31.2357,
      },
      homeButton: null,
      layerVisibility: {
        projects: true,
        mapLibraries: true,
        fixedPoints: true,
        ...createAdministrativeBoundaryVisibility(false),
        vrsCoordinates: true,
        jxlCoordinates: true,
        jxlPolygons: true,
        userLocation: true,
      },
      geodesiaLayerCancels: {},
      geodesiaLayerLoaded: {},
      geodesiaLayerLoading: {},
      administrativeBoundarySketchReady: false,
    }
  },
  computed: {
    canViewAdministrativeBoundaries() {
      try {
        return typeof this.hasPermission === 'function'
          && this.hasPermission('view administrative_boundaries')
      } catch (e) {
        return false
      }
    },
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    this.cancelAllGeodesiaLayerRequests()
    if (this.view) {
      this.view.destroy()
    }
  },
  methods: {
    async initMap() {
      this.mapLoading = true
      try {
        const modules = await loadArcgisModules(
          [
            'esri/Map',
            'esri/views/MapView',
            'esri/layers/GraphicsLayer',
            'esri/Graphic',
            'esri/geometry/Point',
            'esri/geometry/Polygon',
            'esri/symbols/SimpleMarkerSymbol',
            'esri/symbols/SimpleFillSymbol',
            'esri/symbols/SimpleLineSymbol',
            'esri/symbols/PictureMarkerSymbol',
            'esri/widgets/Search',
            'esri/widgets/LayerList',
            'esri/widgets/Sketch',
            'esri/widgets/Popup',
            'esri/geometry/Extent',
            'esri/geometry/geometryEngine',
          ],
        )

        this.arcgisModules = {
          Map: modules[0],
          MapView: modules[1],
          GraphicsLayer: modules[2],
          Graphic: modules[3],
          Point: modules[4],
          Polygon: modules[5],
          SimpleMarkerSymbol: modules[6],
          SimpleFillSymbol: modules[7],
          SimpleLineSymbol: modules[8],
          PictureMarkerSymbol: modules[9],
          Search: modules[10],
          LayerList: modules[11],
          Sketch: modules[12],
          Popup: modules[13],
          Extent: modules[14],
          geometryEngine: modules[15],
        }

        // Create separate layers for each data type
        this.projectsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'المشاريع',
          visible: true,
        })
        this.mapLibrariesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'مكتبات الخرائط',
          visible: true,
        })
        this.fixedPointsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'النقاط الثابتة',
          visible: true,
        })
        const administrativeBoundaryLayers = {}
        ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
          const key = administrativeBoundaryLayerKey(item.type)
          administrativeBoundaryLayers[item.type] = new this.arcgisModules.GraphicsLayer({
            id: administrativeBoundaryLayerId(item.type),
            title: item.title,
            listMode: 'show',
            visible: this.canViewAdministrativeBoundaries
              && this.layerVisibility[key] === true,
          })
        })
        this.administrativeBoundaryLayers = administrativeBoundaryLayers
        this.vrsCoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات VRS',
          visible: true,
        })
        this.jxlCoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات JXL',
          visible: true,
        })
        this.jxlPolygonsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'مضلعات JXL',
          visible: true,
        })
        this.userLocationLayer = new this.arcgisModules.GraphicsLayer({
          title: 'موقعي الحالي',
          visible: true,
        })

        this.map = new this.arcgisModules.Map({
          basemap: 'hybrid',
          layers: [
            ...Object.values(administrativeBoundaryLayers),
            this.projectsLayer,
            this.mapLibrariesLayer,
            this.fixedPointsLayer,
            this.vrsCoordinatesLayer,
            this.jxlPolygonsLayer,
            this.jxlCoordinatesLayer,
            this.userLocationLayer,
          ],
        })

        // Try to get user location first to center the map
        let mapCenter = [this.defaultCenter.longitude, this.defaultCenter.latitude]
        let mapZoom = 15

        try {
          const userLocation = await this.getUserCurrentLocation()
          mapCenter = [userLocation.longitude, userLocation.latitude]
          mapZoom = 15 // Zoom in more when showing user location
          this.userLocationObtained = true
          console.log('Using user location as map center:', mapCenter)
        } catch (error) {
          this.userLocationObtained = false
          console.warn('Could not get user location, using default center:', error)
        }

        this.view = new this.arcgisModules.MapView({
          container: this.$refs.esriView,
          map: this.map,
          center: mapCenter,
          zoom: mapZoom,
          popupEnabled: false,
        })

        // Wait for view to be ready
        await this.view.when()

        // Create and configure popup widget (required for view.openPopup() in 4.27+)
        if (this.arcgisModules.Popup) {
          const popup = new this.arcgisModules.Popup({
            dockEnabled: false,
            defaultPopupTemplateEnabled: true,
          })
          this.view.popup = popup
        }

        // Add search widget
        this.addSearchWidget()

        // Add LayerList widget (built-in layer visibility control)
        // this.addLayerListWidget();

        // Add Sketch widget with settings panel (includes snapping layers)
        this.addSketchWidget()

        // Add home (current location) button next to zoom controls
        this.addHomeButtonToView()

        // Bind click events after view is ready
        this.bindMapClickEvents()

        // Get user location automatically and add marker
        this.addUserLocation().catch(err => {
          console.warn('Could not add user location marker:', err)
        })

        // Load map data automatically
        await this.loadMapData()
      } catch (error) {
        console.error('Failed to initialize Esri map', error)
        this.error = 'فشل في تحميل الخريطة'
      } finally {
        this.mapLoading = false
      }
    },
    toggleLayer(layerName) {
      if (!this.map) return

      const layerMap = {
        projects: this.projectsLayer,
        mapLibraries: this.mapLibrariesLayer,
        fixedPoints: this.fixedPointsLayer,
        vrsCoordinates: this.vrsCoordinatesLayer,
        jxlCoordinates: this.jxlCoordinatesLayer,
        jxlPolygons: this.jxlPolygonsLayer,
        userLocation: this.userLocationLayer,
      }
      ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
        layerMap[administrativeBoundaryLayerKey(item.type)] = this.administrativeBoundaryLayers?.[item.type]
      })

      const layer = layerMap[layerName]
      if (layer) {
        layer.visible = this.layerVisibility[layerName]
      }
      if (['vrsCoordinates', 'jxlCoordinates', 'jxlPolygons'].includes(layerName)) {
        if (this.layerVisibility[layerName]) {
          this.loadGeodesiaMapLayer(layerName)
        } else {
          this.cancelGeodesiaLayerRequest(layerName)
        }
      }
      if (
        isAdministrativeBoundaryLayerKey(layerName)
        && this.layerVisibility[layerName]
        && this.canViewAdministrativeBoundaries
      ) {
        const type = typeFromAdministrativeBoundaryLayerKey(layerName)
        const typeLayer = this.administrativeBoundaryLayers?.[type]
        if (typeLayer && typeLayer.graphics.length === 0) {
          this.loadAdministrativeBoundaryType(type, { force: true })
        }
      }
    },
    updateLayerVisibility() {
      if (!this.map) return

      if (this.projectsLayer) {
        this.projectsLayer.visible = this.layerVisibility.projects
      }
      if (this.mapLibrariesLayer) {
        this.mapLibrariesLayer.visible = this.layerVisibility.mapLibraries
      }
      ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
        const typeLayer = this.administrativeBoundaryLayers?.[item.type]
        if (typeLayer) {
          typeLayer.visible = this.canViewAdministrativeBoundaries
            && this.layerVisibility[administrativeBoundaryLayerKey(item.type)] === true
        }
      })
      if (this.fixedPointsLayer) {
        this.fixedPointsLayer.visible = this.layerVisibility.fixedPoints
      }
      if (this.vrsCoordinatesLayer) {
        this.vrsCoordinatesLayer.visible = this.layerVisibility.vrsCoordinates
      }
      if (this.jxlCoordinatesLayer) {
        this.jxlCoordinatesLayer.visible = this.layerVisibility.jxlCoordinates
      }
      if (this.jxlPolygonsLayer) {
        this.jxlPolygonsLayer.visible = this.layerVisibility.jxlPolygons
      }
      if (this.userLocationLayer) {
        this.userLocationLayer.visible = this.layerVisibility.userLocation
      }
    },
    addSearchWidget() {
      if (!this.view || !this.arcgisModules) return
      const search = new this.arcgisModules.Search({
        view: this.view,
        includeDefaultSources: true,
      })
      this.view.ui.add(search, 'top-right')
    },
    // addLayerListWidget() {
    //   if (!this.view || !this.arcgisModules) return;
    //   const layerList = new this.arcgisModules.LayerList({
    //     view: this.view,
    //     listItemCreatedFunction: (event) => {
    //       const item = event.item;
    //       if (item.layer.type !== 'group') {
    //         // Don't show legend for graphics layers
    //         item.panel = {
    //           content: 'legend',
    //           open: false,
    //         };
    //       }
    //     },
    //   });
    //   this.view.ui.add(layerList, 'top-right');
    // },
    addSketchWidget() {
      if (!this.view || !this.arcgisModules || !this.projectsLayer) return

      // Create a graphics layer for sketch operations
      if (!this.sketchLayer) {
        this.sketchLayer = new this.arcgisModules.GraphicsLayer({
          title: 'Sketch Layer',
        })
        this.map.add(this.sketchLayer)
      }

      // Create feature sources with layer mapping
      const featureSources = [
        {
          layer: this.userLocationLayer,
          enabled: true,
        },
        {
          layer: this.projectsLayer,
          enabled: true,
        },
        {
          layer: this.mapLibrariesLayer,
          enabled: true,
        },
        {
          layer: this.fixedPointsLayer,
          enabled: true,
        },
        ...(this.canViewAdministrativeBoundaries
          ? ADMINISTRATIVE_BOUNDARY_TYPES.map(item => ({
            layer: this.administrativeBoundaryLayers[item.type],
            enabled: this.layerVisibility[administrativeBoundaryLayerKey(item.type)] === true,
          })).filter(source => source.layer)
          : []),
        {
          layer: this.vrsCoordinatesLayer,
          enabled: true,
        },
        {
          layer: this.jxlCoordinatesLayer,
          enabled: true,
        },
        {
          layer: this.jxlPolygonsLayer,
          enabled: true,
        },
      ]

      // Create layer mapping for easy lookup
      const layerMap = {

        [this.userLocationLayer.id]: this.userLocationLayer,
        [this.projectsLayer.id]: this.projectsLayer,
        [this.mapLibrariesLayer.id]: this.mapLibrariesLayer,
        [this.fixedPointsLayer.id]: this.fixedPointsLayer,
        ...Object.fromEntries(
          ADMINISTRATIVE_BOUNDARY_TYPES
            .map(item => this.administrativeBoundaryLayers?.[item.type])
            .filter(Boolean)
            .map(layer => [layer.id, layer]),
        ),
        [this.vrsCoordinatesLayer.id]: this.vrsCoordinatesLayer,
        [this.jxlCoordinatesLayer.id]: this.jxlCoordinatesLayer,
        [this.jxlPolygonsLayer.id]: this.jxlPolygonsLayer,
      }

      const sketch = new this.arcgisModules.Sketch({
        view: this.view,
        layer: this.sketchLayer,
        // Configure snapping options to use map layers
        snappingOptions: {
          enabled: true,
          selfEnabled: true,
          featureEnabled: true,
          featureSources,
        },
        // Enable tooltips and geometry guides
        tooltipOptions: {
          enabled: true,
        },
        // Enable geometry guides
        defaultUpdateOptions: {
          tooltipOptions: {
            enabled: true,
          },
        },
      })

      // Function to sync layer visibility with snapping enabled state
      const syncLayerVisibility = () => {
        const { snappingOptions } = sketch.viewModel
        if (snappingOptions && snappingOptions.featureSources) {
          snappingOptions.featureSources.forEach(source => {
            if (!source.layer || !layerMap[source.layer.id]) return
            const type = ADMINISTRATIVE_BOUNDARY_TYPES.find(
              item => this.administrativeBoundaryLayers?.[item.type] === source.layer,
            )?.type
            if (type) {
              const enabled = this.canViewAdministrativeBoundaries
                && this.layerVisibility[administrativeBoundaryLayerKey(type)] === true
              if (!this.administrativeBoundarySketchReady || source.enabled !== enabled) {
                source.enabled = enabled
              }
              source.layer.visible = enabled
              return
            }
            layerMap[source.layer.id].visible = source.enabled !== false
          })
        }
      }

      // Watch each feature source's enabled property
      featureSources.forEach(source => {
        if (source.watch) {
          source.watch('enabled', enabled => {
            const type = ADMINISTRATIVE_BOUNDARY_TYPES.find(
              item => this.administrativeBoundaryLayers?.[item.type] === source.layer,
            )?.type
            if (type) {
              const key = administrativeBoundaryLayerKey(type)
              if (!this.administrativeBoundarySketchReady) {
                source.enabled = this.layerVisibility[key] === true
                if (source.layer) source.layer.visible = source.enabled && this.canViewAdministrativeBoundaries
                return
              }
              this.layerVisibility[key] = enabled === true
              if (source.layer) {
                source.layer.visible = enabled === true && this.canViewAdministrativeBoundaries
              }
              if (
                enabled
                && this.canViewAdministrativeBoundaries
                && source.layer?.graphics?.length === 0
              ) {
                this.loadAdministrativeBoundaryType(type, { force: true })
              }
              return
            }
            if (source.layer && layerMap[source.layer.id]) {
              layerMap[source.layer.id].visible = enabled !== false
            }
          })
        }
      })

      // Watch for changes in snapping options
      if (sketch.viewModel.snappingOptions) {
        // Watch the featureSources array
        if (sketch.viewModel.snappingOptions.featureSources) {
          sketch.viewModel.snappingOptions.featureSources.forEach(source => {
            if (source.watch) {
              source.watch('enabled', () => {
                syncLayerVisibility()
              })
            }
          })
        }

        // Watch the featureSources property itself
        sketch.viewModel.snappingOptions.watch('featureSources', () => {
          syncLayerVisibility()
        })
      }

      // Also watch the viewModel's snappingOptions property
      sketch.viewModel.watch('snappingOptions', () => {
        syncLayerVisibility()
      })

      // Set up interval to check for changes (fallback method)
      // This ensures we catch changes even if watchers don't fire
      const visibilityCheckInterval = setInterval(() => {
        syncLayerVisibility()
      }, 300)

      this.administrativeBoundarySketchReady = false
      syncLayerVisibility()
      this.$nextTick(() => {
        syncLayerVisibility()
        window.setTimeout(() => {
          this.administrativeBoundarySketchReady = true
          syncLayerVisibility()
        }, 1000)
      })

      // Clean up interval when component is destroyed
      this.$once('hook:beforeDestroy', () => {
        if (visibilityCheckInterval) {
          clearInterval(visibilityCheckInterval)
        }
      })

      // Add sketch widget to the view
      this.view.ui.add(sketch, 'top-right')
      this.sketch = sketch
    },
    addHomeButtonToView() {
      if (!this.view) return

      const button = document.createElement('button')
      button.className = 'esri-widget--button esri-widget home-location-button'
      button.title = 'الذهاب إلى موقعي الحالي'

      button.addEventListener('click', () => {
        this.addUserLocation()
      })

      // Keep reference so we can show loader state
      this.homeButton = button
      this.setHomeButtonLoading(this.locationLoading)

      // Place it with the zoom controls (top-left)
      this.view.ui.add(button, 'top-left')
    },
    bindMapClickEvents() {
      if (!this.view) return
      this.view.on('click', async event => {
        const hit = await this.view.hitTest(event, {
          include: [
            this.projectsLayer,
            this.mapLibrariesLayer,
            this.fixedPointsLayer,
            ...ADMINISTRATIVE_BOUNDARY_TYPES
              .map(item => this.administrativeBoundaryLayers?.[item.type])
              .filter(Boolean),
            this.vrsCoordinatesLayer,
            this.jxlCoordinatesLayer,
            this.jxlPolygonsLayer,
            this.userLocationLayer,
          ].filter(Boolean),
        })

        if (hit?.results?.length > 0) {
          const result = hit.results[0]
          const { graphic } = result
          const { attributes } = graphic

          // Handle JXL point click to show polygon and enhanced popup
          if (graphic.layer === this.jxlCoordinatesLayer && attributes && attributes.jxl_file_id) {
            // Show the polygon for this point
            this.showJxlPolygon(attributes.jxl_file_id)

            // Enhance popup content to include polygon info
            const enhancedPopupContent = this.buildJxlPointPopupWithPolygon(attributes)

            // Use the new API: view.openPopup() with enhanced content
            this.view.openPopup({
              location: result.mapPoint,
              title: attributes.point_name || `JXL Point ${attributes.id || ''}`,
              content: enhancedPopupContent,
              updateLocationEnabled: true,
              popupEnabled: true,
            })
          } else {
            // Use the new API: view.openPopup() instead of view.popup.open()
            // Set location to the clicked point so popup appears at the item location
            this.view.openPopup({
              location: result.mapPoint,
              features: [result.graphic],
              updateLocationEnabled: true, // Allow popup to update location when map moves
              popupEnabled: true,
            })
          }
        } else {
          // Use the new API: view.closePopup() instead of view.popup.close()
          this.view.closePopup()
        }
      })
    },
    async loadMapData() {
      if (this.loading) return
      this.loading = true
      this.error = null
      this.dataStats = {
        projects: 0,
        mapLibraries: 0,
        fixedPoints: 0,
        administrativeBoundaries: 0,
        vrsCoordinates: 0,
        jxlCoordinates: 0,
        jxlPolygons: 0,
      }

      try {
        console.log('Loading map data with chunk_size:', this.chunkSize)
        const response = await mapLibraryApi.getAllMapData({
          chunk_size: this.chunkSize,
          include_administrative_boundaries: 0,
        })

        console.log('Map data response:', response)
        console.log('Response.data:', response.data)
        console.log('Response keys:', Object.keys(response))
        console.log('Has response.data.projects?', response.data?.projects)
        console.log('Has response.projects?', response.projects)

        // Handle both response.data and direct response structure
        // Check if data is in response.data first (axios default), then check response directly
        let data = {}
        if (response.data && (response.data.projects || response.data.map_libraries || response.data.fixed_points)) {
          data = response.data
          console.log('Using response.data')
        } else if (response.projects || response.map_libraries || response.fixed_points) {
          data = response
          console.log('Using response directly')
        } else {
          data = {}
          console.warn('Could not find data in response')
        }

        const projects = data.projects || []
        const mapLibraries = data.map_libraries || []
        const fixedPoints = data.fixed_points || []

        console.log(`Received ${projects.length} projects, ${mapLibraries.length} map libraries, ${fixedPoints.length} fixed points`)
        console.log('Sample project:', projects[0])
        console.log('Sample map library:', mapLibraries[0])
        console.log('Sample fixed point:', fixedPoints[0])

        // Update stats
        this.dataStats = {
          projects: projects.length,
          mapLibraries: mapLibraries.length,
          fixedPoints: fixedPoints.length,
        }

        this.debugInfo = `تم استلام ${projects.length} مشروع، ${mapLibraries.length} مكتبة خرائط، ${fixedPoints.length} نقطة ثابتة`

        // Ensure view is ready
        if (!this.view) {
          console.error('View is not ready yet')
          return
        }

        // Ensure view is fully loaded
        await this.view.when()

        // Clear existing graphics
        if (this.projectsLayer) this.projectsLayer.removeAll()
        if (this.mapLibrariesLayer) this.mapLibrariesLayer.removeAll()
        if (this.fixedPointsLayer) this.fixedPointsLayer.removeAll()
        if (this.vrsCoordinatesLayer) this.vrsCoordinatesLayer.removeAll()
        if (this.jxlCoordinatesLayer) this.jxlCoordinatesLayer.removeAll()
        if (this.jxlPolygonsLayer) this.jxlPolygonsLayer.removeAll()
        this.currentPolygonGraphic = null

        // Add projects
        if (projects.length > 0) {
          this.addProjectsToMap(projects)
        }

        // Add map libraries
        if (mapLibraries.length > 0) {
          this.addMapLibrariesToMap(mapLibraries)
        }

        // Add fixed points
        if (fixedPoints.length > 0) {
          this.addFixedPointsToMap(fixedPoints)
        }

        // Load VRS / JXL / polygons independently
        await this.loadVisibleGeodesiaLayers()

        // Wait a bit for graphics to render
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))

        // Zoom to extent if we have data, but only if user location was not obtained
        // This preserves the user's location view when they grant permission
        if (this.view && (projects.length > 0 || mapLibraries.length > 0 || fixedPoints.length > 0 || this.dataStats.vrsCoordinates > 0 || this.dataStats.jxlCoordinates > 0)) {
          if (!this.userLocationObtained) {
            // Only zoom to extent if we don't have user location
            await this.zoomToExtent()
          } else {
            console.log('Preserving user location view - skipping zoom to extent')
          }
        } else {
          console.log('No data to display on map')
        }
      } catch (error) {
        console.error('Error loading map data:', error)
        if (error.response?.status === 401) {
          this.error = 'يرجى تسجيل الدخول'
        } else if (error.response?.status === 403) {
          this.error = 'ليس لديك صلاحية لعرض هذه البيانات'
        } else {
          this.error = error.response?.data?.message || error.message || 'حدث خطأ أثناء تحميل البيانات'
        }
      } finally {
        this.loading = false
      }
    },
    addProjectsToMap(projects) {
      if (!this.projectsLayer || !this.arcgisModules || !projects.length) {
        console.log('Cannot add projects - missing layer or modules or no projects')
        return
      }

      const {
        Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
      } = this.arcgisModules
      let addedCount = 0

      projects.forEach(project => {
        try {
          // Extract coordinates from geometry
          const coordinates = project.geometry?.coordinates
          if (!coordinates || !coordinates[0] || !coordinates[0].length) {
            console.warn('Invalid project geometry:', project)
            return
          }

          // Ensure coordinates are in [lng, lat] format
          const rings = coordinates[0].map(coord => {
            // Handle both [lng, lat] and [lat, lng] formats
            if (Array.isArray(coord) && coord.length >= 2) {
              // If lat > 90 or lat < -90, it's likely swapped
              if (Math.abs(coord[0]) > 90 || Math.abs(coord[1]) > 90) {
                return [coord[1], coord[0]] // Swap if needed
              }
              return [coord[0], coord[1]]
            }
            return coord
          })

          // Create polygon geometry
          const polygon = new Polygon({
            rings,
            spatialReference: { wkid: 4326 },
          })

          // Create symbol
          const symbol = new SimpleFillSymbol({
            color: [255, 0, 0, 0.5], // Red with transparency
            outline: new SimpleLineSymbol({
              color: [255, 0, 0],
              width: 2,
            }),
          })

          // Build popup content
          const popupContent = this.buildProjectPopupContent(project.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: polygon,
            symbol,
            attributes: project.attributes,
            popupTemplate: {
              title: project.attributes.name || 'مشروع',
              content: popupContent,
            },
          })

          this.projectsLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding project to map:', error, project)
        }
      })

      console.log(`Added ${addedCount} projects to map out of ${projects.length}`)
    },
    addMapLibrariesToMap(mapLibraries) {
      if (!this.mapLibrariesLayer || !this.arcgisModules || !mapLibraries.length) {
        console.log('Cannot add map libraries - missing layer or modules or no libraries')
        return
      }

      const {
        Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
      } = this.arcgisModules
      let addedCount = 0

      mapLibraries.forEach(library => {
        try {
          // Use geometry_geojson if available, otherwise use geometry
          const geometryData = library.geometry_geojson && Object.keys(library.geometry_geojson).length > 0
            ? library.geometry_geojson
            : library.geometry

          if (!geometryData) {
            console.warn('Invalid map library geometry - no geometry data:', library)
            return
          }

          // Handle different geometry formats
          let coordinates = null

          if (geometryData.coordinates) {
            coordinates = geometryData.coordinates
          } else if (geometryData.rings) {
            // Already in ArcGIS format
            coordinates = [geometryData.rings]
          } else {
            console.warn('Invalid map library geometry - no coordinates or rings:', library)
            return
          }

          // Validate coordinates structure
          if (!Array.isArray(coordinates) || coordinates.length === 0) {
            console.warn('Invalid map library geometry - coordinates is not an array:', library)
            return
          }

          // Get the first ring (outer ring for polygon)
          const firstRing = coordinates[0]
          if (!Array.isArray(firstRing) || firstRing.length < 3) {
            console.warn('Invalid map library geometry - first ring is invalid:', library)
            return
          }

          // Convert coordinates to [lng, lat] format
          const rings = firstRing.map(coord => {
            if (!Array.isArray(coord) || coord.length < 2) {
              console.warn('Invalid coordinate in map library:', coord)
              return null
            }

            const lng = Number(coord[0])
            const lat = Number(coord[1])

            // Validate coordinates are numbers
            if (isNaN(lng) || isNaN(lat)) {
              console.warn('Invalid coordinate values (NaN):', coord)
              return null
            }

            // Check if coordinates are swapped (lat > 90 means it's likely longitude)
            if (Math.abs(lat) > 90) {
              // Likely swapped, but also check if lng is in valid lat range
              if (Math.abs(lng) <= 90) {
                return [lat, lng] // Swap
              }
            }

            return [lng, lat]
          }).filter(coord => coord !== null) // Remove invalid coordinates

          // Validate we have at least 3 points for a polygon
          if (rings.length < 3) {
            console.warn('Invalid map library geometry - not enough valid coordinates:', library)
            return
          }

          // Create polygon geometry
          const polygon = new Polygon({
            rings: [rings], // Wrap in array for rings
            spatialReference: { wkid: 4326 },
          })

          // Create symbol
          const symbol = new SimpleFillSymbol({
            color: [0, 0, 255, 0.3], // Blue with transparency
            outline: new SimpleLineSymbol({
              color: [0, 0, 255],
              width: 1,
            }),
          })

          // Build popup content
          const popupContent = this.buildMapLibraryPopupContent(library.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: polygon,
            symbol,
            attributes: library.attributes,
            popupTemplate: {
              title: 'مكتبة خرائط',
              content: popupContent,
            },
          })

          this.mapLibrariesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding map library to map:', error, library)
        }
      })

      console.log(`Added ${addedCount} map libraries to map out of ${mapLibraries.length}`)
    },
    addFixedPointsToMap(fixedPoints) {
      if (!this.fixedPointsLayer || !this.arcgisModules || !fixedPoints.length) {
        console.log('Cannot add fixed points - missing layer or modules or no points')
        return
      }

      const {
        Point, Graphic, SimpleMarkerSymbol, PictureMarkerSymbol,
      } = this.arcgisModules
      let addedCount = 0

      fixedPoints.forEach(point => {
        try {
          const coordinates = point.geometry?.coordinates
          if (!coordinates || coordinates.length < 2) {
            console.warn('Invalid fixed point geometry:', point)
            return
          }

          let [longitude, latitude] = coordinates

          // Handle swapped coordinates
          if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) {
            [longitude, latitude] = [latitude, longitude]
          }

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            console.warn('Invalid coordinates for fixed point:', coordinates)
            return
          }

          // Create point geometry
          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          // Use accuracy degree color if available
          let symbol
          const colorHex = point.attributes?.accuracy_degree_color || '#00ff00'
          const rgb = this.hexToRgb(colorHex)

          // Try to use custom pin icon, fallback to simple marker
          try {
            const pinSvg = this.createPinIcon(colorHex)
            symbol = new PictureMarkerSymbol({
              url: pinSvg,
              width: 32,
              height: 40,
              xoffset: 0,
              yoffset: 20,
            })
          } catch (error) {
            // Fallback to simple marker
            symbol = new SimpleMarkerSymbol({
              style: 'circle',
              color: rgb,
              size: 8,
              outline: {
                color: [255, 255, 255],
                width: 1,
              },
            })
          }

          // Build popup content
          const popupContent = this.buildFixedPointPopupContent(point.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol,
            attributes: point.attributes,
            popupTemplate: {
              title: `نقطة ثابتة: ${point.attributes?.code || 'N/A'}`,
              content: popupContent,
            },
          })

          this.fixedPointsLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding fixed point to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} fixed points to map out of ${fixedPoints.length}`)
    },
    async loadAllAdministrativeBoundaryTypes({ force = false } = {}) {
      if (!this.canViewAdministrativeBoundaries) return
      const counts = await Promise.all(
        ADMINISTRATIVE_BOUNDARY_TYPES.map(item => (
          this.loadAdministrativeBoundaryType(item.type, { force })
        )),
      )
      this.dataStats.administrativeBoundaries = counts.reduce((sum, count) => sum + (Number(count) || 0), 0)
    },
    async loadAdministrativeBoundaries({ force = false, type = null } = {}) {
      if (type) {
        await this.loadAdministrativeBoundaryType(type, { force })
        return
      }
      await this.loadAllAdministrativeBoundaryTypes({ force })
    },
    async loadAdministrativeBoundaryType(type, { force = false } = {}) {
      const layer = this.administrativeBoundaryLayers?.[type]
      if (!this.canViewAdministrativeBoundaries || !layer || !this.arcgisModules) {
        return 0
      }

      const { Graphic } = this.arcgisModules
      try {
        const year = this.administrativeBoundariesYear || DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR
        const featureCollection = await fetchAdministrativeBoundariesGeoJson(year, { force, type })
        const items = normalizeAdministrativeBoundaryItems(featureCollection)
        const graphics = mapAdministrativeBoundaryItemsToGraphics(items, type)

        layer.removeAll()
        graphics.forEach(graphic => {
          layer.add(new Graphic(graphic))
        })

        layer.visible = this.layerVisibility[administrativeBoundaryLayerKey(type)] === true
        return graphics.length
      } catch (error) {
        console.error(`Error loading administrative boundaries (${type}):`, error)
        return 0
      }
    },
    async loadVrsCoordinates() {
      return this.loadGeodesiaMapLayer('vrsCoordinates')
    },
    addVrsCoordinatesToMap(points) {
      if (!this.vrsCoordinatesLayer || !this.arcgisModules || !points.length) {
        console.log('Cannot add VRS coordinates - missing layer or modules or no points')
        return
      }

      const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules
      let addedCount = 0

      // Create marker symbol - orange color to match VrsCoordinatesMap.vue
      const markerSymbol = new SimpleMarkerSymbol({
        style: 'circle',
        color: [226, 119, 40, 0.8], // Orange color
        size: 8,
        outline: {
          color: [255, 255, 255, 0.8],
          width: 2,
        },
      })

      points.forEach(point => {
        try {
          const coordinates = point.geometry?.coordinates
          if (!coordinates || coordinates.length < 2) {
            console.warn('Invalid VRS coordinate geometry:', point)
            return
          }

          const [longitude, latitude] = coordinates

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            console.warn('Invalid coordinates for VRS point:', coordinates)
            return
          }

          // Create point geometry
          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          // Build popup content
          const attributes = point.attributes || {}
          const popupContent = this.buildVrsCoordinatePopupContent(attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol: markerSymbol,
            attributes,
            popupTemplate: {
              title: attributes.point_name || `VRS Point ${attributes.id || ''}`,
              content: popupContent,
            },
          })

          this.vrsCoordinatesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding VRS coordinate to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} VRS coordinates to map out of ${points.length}`)
    },
    buildVrsCoordinatePopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.id) {
        content += `<b>ID:</b> ${attributes.id}<br>`
      }
      if (attributes.point_name) {
        content += `<b>اسم النقطة:</b> ${attributes.point_name}<br>`
      }
      if (attributes.latitude !== undefined && attributes.latitude !== null) {
        content += `<b>خط العرض:</b> ${parseFloat(attributes.latitude).toFixed(8)}<br>`
      }
      if (attributes.longitude !== undefined && attributes.longitude !== null) {
        content += `<b>خط الطول:</b> ${parseFloat(attributes.longitude).toFixed(8)}<br>`
      }
      if (attributes.elevation !== undefined && attributes.elevation !== null) {
        content += `<b>الارتفاع:</b> ${attributes.elevation}m<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.point_description) {
        content += `<b>الوصف:</b> ${attributes.point_description}<br>`
      }
      if (attributes.utm_east && attributes.utm_north) {
        content += `<b>UTM:</b> E: ${attributes.utm_east}, N: ${attributes.utm_north}`
        if (attributes.utm_zone) {
          content += ` (${attributes.utm_zone})`
        }
        content += '<br>'
      }
      if (attributes.accuracy !== undefined && attributes.accuracy !== null) {
        content += `<b>الدقة:</b> ${attributes.accuracy}m<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    async loadJxlCoordinates() {
      return this.loadGeodesiaMapLayer('jxlCoordinates')
    },
    async loadJxlPolygons() {
      return this.loadGeodesiaMapLayer('jxlPolygons')
    },
    cancelGeodesiaLayerRequest(layerKey) {
      const source = this.geodesiaLayerCancels?.[layerKey]
      if (!source) return
      source.cancel('layer-toggled-off')
      this.$delete(this.geodesiaLayerCancels, layerKey)
    },
    cancelAllGeodesiaLayerRequests() {
      Object.keys(this.geodesiaLayerCancels || {}).forEach(key => {
        this.cancelGeodesiaLayerRequest(key)
      })
    },
    notifyGeodesiaLayerTruncated(payload) {
      if (!isGeodesiaLayerTruncated(payload) || !this.$toast?.warning) return
      this.$toast.warning(GEODESIA_LAYER_TRUNCATED_MESSAGE)
    },
    async loadVisibleGeodesiaLayers() {
      const tasks = []
      if (this.layerVisibility.vrsCoordinates) tasks.push(this.loadGeodesiaMapLayer('vrsCoordinates'))
      if (this.layerVisibility.jxlCoordinates) tasks.push(this.loadGeodesiaMapLayer('jxlCoordinates'))
      if (this.layerVisibility.jxlPolygons) tasks.push(this.loadGeodesiaMapLayer('jxlPolygons'))
      await Promise.all(tasks)
    },
    async loadGeodesiaMapLayer(layerKey, { force = false } = {}) {
      if (this.geodesiaLayerLoading[layerKey]) return
      if (!force && this.geodesiaLayerLoaded[layerKey]) return

      const layer = layerKey === 'vrsCoordinates'
        ? this.vrsCoordinatesLayer
        : layerKey === 'jxlPolygons'
          ? this.jxlPolygonsLayer
          : this.jxlCoordinatesLayer
      if (!layer || !this.arcgisModules) return

      this.cancelGeodesiaLayerRequest(layerKey)
      this.$set(this.geodesiaLayerLoading, layerKey, true)
      const cancelSource = createGeodesiaLayerCancelSource()
      this.$set(this.geodesiaLayerCancels, layerKey, cancelSource)

      try {
        const response = await geodesiaApi.getGeodesiaMapLayer(layerKey, {}, { cancelToken: cancelSource.token })
        const payload = unwrapGeodesiaLayerPayload(response)
        const features = getGeodesiaLayerFeatures(payload, layerKey)

        if (layerKey === 'vrsCoordinates') {
          this.vrsCoordinatesLayer.removeAll()
          this.dataStats.vrsCoordinates = features.length
          if (features.length) this.addVrsCoordinatesToMap(features)
        } else if (layerKey === 'jxlPolygons') {
          this.jxlData.polygons = features
          this.dataStats.jxlPolygons = features.length
        } else {
          this.jxlCoordinatesLayer.removeAll()
          this.jxlData.points = features
          this.dataStats.jxlCoordinates = features.length
          if (features.length) this.addJxlCoordinatesToMap(features)
        }

        this.notifyGeodesiaLayerTruncated(payload)
        this.$set(this.geodesiaLayerLoaded, layerKey, true)
      } catch (error) {
        if (isGeodesiaLayerRequestCanceled(error)) {
          this.$set(this.geodesiaLayerLoaded, layerKey, false)
          return
        }
        console.error(`Error loading ${layerKey}:`, error)
        this.$set(this.geodesiaLayerLoaded, layerKey, false)
      } finally {
        this.$set(this.geodesiaLayerLoading, layerKey, false)
        if (this.geodesiaLayerCancels[layerKey] === cancelSource) {
          this.$delete(this.geodesiaLayerCancels, layerKey)
        }
      }
    },
    addJxlCoordinatesToMap(points) {
      if (!this.jxlCoordinatesLayer || !this.arcgisModules || !points.length) {
        console.log('Cannot add JXL coordinates - missing layer or modules or no points')
        return
      }

      const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules
      let addedCount = 0

      // Create marker symbol - green color to distinguish from VRS
      const markerSymbol = new SimpleMarkerSymbol({
        style: 'circle',
        color: [0, 200, 0, 0.8], // Green color
        size: 8,
        outline: {
          color: [255, 255, 255, 0.8],
          width: 2,
        },
      })

      points.forEach(point => {
        try {
          const coordinates = point.geometry?.coordinates
          if (!coordinates || coordinates.length < 2) {
            console.warn('Invalid JXL coordinate geometry:', point)
            return
          }

          const [longitude, latitude] = coordinates

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            console.warn('Invalid coordinates for JXL point:', coordinates)
            return
          }

          // Create point geometry
          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          // Build popup content
          const attributes = point.attributes || {}
          const popupContent = this.buildJxlCoordinatePopupContent(attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol: markerSymbol,
            attributes,
            popupTemplate: {
              title: attributes.point_name || `JXL Point ${attributes.id || ''}`,
              content: popupContent,
            },
          })

          this.jxlCoordinatesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding JXL coordinate to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} JXL coordinates to map out of ${points.length}`)
    },
    buildJxlCoordinatePopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.id) {
        content += `<b>ID:</b> ${attributes.id}<br>`
      }
      if (attributes.point_name) {
        content += `<b>اسم النقطة:</b> ${attributes.point_name}<br>`
      }
      if (attributes.latitude !== undefined && attributes.latitude !== null) {
        content += `<b>خط العرض:</b> ${parseFloat(attributes.latitude).toFixed(8)}<br>`
      }
      if (attributes.longitude !== undefined && attributes.longitude !== null) {
        content += `<b>خط الطول:</b> ${parseFloat(attributes.longitude).toFixed(8)}<br>`
      }
      if (attributes.elevation !== undefined && attributes.elevation !== null) {
        content += `<b>الارتفاع:</b> ${attributes.elevation}m<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.point_description) {
        content += `<b>الوصف:</b> ${attributes.point_description}<br>`
      }
      if (attributes.utm_east && attributes.utm_north) {
        content += `<b>UTM:</b> E: ${attributes.utm_east}, N: ${attributes.utm_north}`
        if (attributes.utm_zone) {
          content += ` (${attributes.utm_zone})`
        }
        content += '<br>'
      }
      if (attributes.accuracy !== undefined && attributes.accuracy !== null) {
        content += `<b>الدقة:</b> ${attributes.accuracy}m<br>`
      }
      if (attributes.project_id) {
        content += `<b>معرف المشروع:</b> ${attributes.project_id}<br>`
      }
      if (attributes.project_name) {
        content += `<b>اسم المشروع:</b> ${attributes.project_name}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    buildJxlPointPopupWithPolygon(pointAttributes) {
      if (!pointAttributes) return 'لا توجد معلومات متاحة'

      // Build point info
      let content = '<div style="padding: 10px;"><h5>معلومات النقطة</h5>'
      content += this.buildJxlCoordinatePopupContent(pointAttributes)

      // Find and add polygon info
      if (pointAttributes.jxl_file_id) {
        const polygon = this.jxlData.polygons.find(p => p.attributes && p.attributes.jxl_file_id === pointAttributes.jxl_file_id)

        if (polygon && polygon.attributes) {
          content += '<hr style="margin: 15px 0;"><h5>معلومات المضلع</h5>'
          content += this.buildJxlPolygonPopupContent(polygon.attributes)
        }
      }

      content += '</div>'
      return content
    },
    showJxlPolygon(jxlFileId) {
      if (!this.jxlPolygonsLayer || !this.arcgisModules || !this.view) {
        return
      }

      // Find polygon for this JXL file
      const polygon = this.jxlData.polygons.find(p => p.attributes && p.attributes.jxl_file_id === jxlFileId)

      if (!polygon) {
        console.warn('Polygon not found for JXL file ID:', jxlFileId)
        return
      }

      // Remove previous polygon if exists
      if (this.currentPolygonGraphic) {
        this.jxlPolygonsLayer.remove(this.currentPolygonGraphic)
        this.currentPolygonGraphic = null
      }

      try {
        const {
          Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, Extent,
        } = this.arcgisModules

        // Get coordinates from polygon geometry
        const { coordinates } = polygon.geometry
        if (!coordinates || !coordinates[0] || !coordinates[0].length) {
          console.warn('Invalid polygon geometry:', polygon)
          return
        }

        // Convert GeoJSON coordinates to ArcGIS rings format
        const rings = coordinates[0].map(coord =>
          // GeoJSON is [lng, lat], ArcGIS expects [lng, lat]
          [coord[0], coord[1]])

        // Create polygon geometry
        const polygonGeometry = new Polygon({
          rings: [rings],
          spatialReference: { wkid: 4326 },
        })

        // Create symbol
        const symbol = new SimpleFillSymbol({
          color: [0, 200, 0, 0.3], // Green with transparency
          outline: new SimpleLineSymbol({
            color: [0, 200, 0],
            width: 2,
          }),
        })

        // Build popup content
        const attributes = polygon.attributes || {}
        const popupContent = this.buildJxlPolygonPopupContent(attributes)

        // Create graphic
        const graphic = new Graphic({
          geometry: polygonGeometry,
          symbol,
          attributes,
          popupTemplate: {
            title: `مضلع JXL: ${attributes.file_name || 'N/A'}`,
            content: popupContent,
          },
        })

        // Add to layer
        this.jxlPolygonsLayer.add(graphic)
        this.currentPolygonGraphic = graphic

        // Fit map to polygon
        this.view.when().then(() => {
          const extent = new Extent({
            xmin: Math.min(...rings.map(r => r[0])),
            ymin: Math.min(...rings.map(r => r[1])),
            xmax: Math.max(...rings.map(r => r[0])),
            ymax: Math.max(...rings.map(r => r[1])),
            spatialReference: { wkid: 4326 },
          })

          this.view.goTo(extent, {
            padding: 50,
            animate: false,
          }).catch(err => {
            console.warn('Error fitting view to polygon:', err)
          })
        })
      } catch (error) {
        console.error('Error displaying JXL polygon:', error)
      }
    },
    buildJxlPolygonPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.jxl_file_id) {
        content += `<b>معرف ملف JXL:</b> ${attributes.jxl_file_id}<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.points_count !== undefined && attributes.points_count !== null) {
        content += `<b>عدد النقاط:</b> ${attributes.points_count}<br>`
      }
      if (attributes.project_id) {
        content += `<b>معرف المشروع:</b> ${attributes.project_id}<br>`
      }
      if (attributes.project_name) {
        content += `<b>اسم المشروع:</b> ${attributes.project_name}<br>`
      }
      if (attributes.status) {
        content += `<b>الحالة:</b> ${attributes.status}<br>`
      }
      if (attributes.assigned_at) {
        content += `<b>تاريخ التعيين:</b> ${attributes.assigned_at}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    async addUserLocation() {
      if (this.locationLoading) return
      this.locationLoading = true
      this.setHomeButtonLoading(true)

      try {
        const location = await this.getUserCurrentLocation()

        if (!this.userLocationLayer || !this.arcgisModules) return

        const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules

        // Clear existing user location
        this.userLocationLayer.removeAll()

        // Create point geometry
        const point = new Point({
          longitude: location.longitude,
          latitude: location.latitude,
          spatialReference: { wkid: 4326 },
        })

        // Create symbol - blue point for current location
        const symbol = new SimpleMarkerSymbol({
          style: 'circle',
          color: [0, 0, 255], // Blue
          size: 12,
          outline: {
            color: [255, 255, 255],
            width: 2,
          },
        })

        // Create graphic
        const graphic = new Graphic({
          geometry: point,
          symbol,
          attributes: {
            id: 'user_location',
            name: 'موقعي الحالي',
          },
          popupTemplate: {
            title: 'موقعي الحالي',
            content: `
              <b>خط العرض:</b> ${location.latitude.toFixed(6)}<br>
              <b>خط الطول:</b> ${location.longitude.toFixed(6)}<br>
              <b>الدقة:</b> ${location.accuracy ? location.accuracy.toFixed(2) : 'N/A'} متر
            `,
          },
        })

        this.userLocationLayer.add(graphic)

        // Center map on user location
        if (this.view) {
          try {
            // Ensure view is ready
            await this.view.when()
            await this.view.goTo({
              center: [location.longitude, location.latitude],
              zoom: 15,
            }, {
              animate: false, // Disable animation to avoid animation errors
            })
          } catch (err) {
            console.warn('Error navigating to user location:', err)
            // Fallback: set center directly without animation
            try {
              this.view.center = [location.longitude, location.latitude]
              this.view.zoom = 15
            } catch (fallbackErr) {
              console.error('Error setting view center directly:', fallbackErr)
            }
          }
        }
      } catch (error) {
        console.error('Error getting user location:', error)
        this.$toast?.error?.('فشل في الحصول على موقعك')
      } finally {
        this.locationLoading = false
        this.setHomeButtonLoading(false)
      }
    },
    setHomeButtonLoading(isLoading) {
      if (!this.homeButton) return

      if (isLoading) {
        this.homeButton.classList.add('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="home-location-spinner"></span>'
      } else {
        this.homeButton.classList.remove('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="esri-icon-home"></span>'
      }
    },
    getUserCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation is not supported by your browser'))
          return
        }

        navigator.geolocation.getCurrentPosition(
          position => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
            })
          },
          error => {
            reject(error)
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          },
        )
      })
    },
    async zoomToExtent() {
      if (!this.view || !this.arcgisModules) return

      try {
        const { Extent } = this.arcgisModules
        const allGraphics = [
          ...this.projectsLayer.graphics.toArray(),
          ...this.mapLibrariesLayer.graphics.toArray(),
          ...this.fixedPointsLayer.graphics.toArray(),
          ...this.vrsCoordinatesLayer.graphics.toArray(),
          ...this.jxlCoordinatesLayer.graphics.toArray(),
          ...this.jxlPolygonsLayer.graphics.toArray(),
        ]

        if (allGraphics.length === 0) return

        // Get all geometries
        const geometries = allGraphics
          .map(g => g.geometry)
          .filter(g => g !== null && g !== undefined)

        if (geometries.length === 0) return

        // Calculate extent from all geometries
        let minX = Infinity
        let minY = Infinity
        let maxX = -Infinity
        let maxY = -Infinity

        geometries.forEach(geometry => {
          if (geometry.type === 'point') {
            minX = Math.min(minX, geometry.longitude)
            maxX = Math.max(maxX, geometry.longitude)
            minY = Math.min(minY, geometry.latitude)
            maxY = Math.max(maxY, geometry.latitude)
          } else if (geometry.type === 'polygon') {
            geometry.rings.forEach(ring => {
              ring.forEach(coord => {
                minX = Math.min(minX, coord[0])
                maxX = Math.max(maxX, coord[0])
                minY = Math.min(minY, coord[1])
                maxY = Math.max(maxY, coord[1])
              })
            })
          }
        })

        if (minX === Infinity) return

        // Add padding
        const padding = 0.1
        const width = maxX - minX
        const height = maxY - minY
        const xPadding = width * padding
        const yPadding = height * padding

        const extent = new Extent({
          xmin: minX - xPadding,
          ymin: minY - yPadding,
          xmax: maxX + xPadding,
          ymax: maxY + yPadding,
          spatialReference: { wkid: 4326 },
        })

        try {
          // Ensure view is ready
          await this.view.when()
          await this.view.goTo(extent, {
            animate: false, // Disable animation to avoid animation errors
          })
        } catch (err) {
          console.warn('Error navigating to extent:', err)
          // Fallback: set extent directly without animation
          try {
            this.view.extent = extent
          } catch (fallbackErr) {
            console.error('Error setting view extent directly:', fallbackErr)
          }
        }
      } catch (error) {
        console.error('Error zooming to extent:', error)
      }
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result
        ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
          0.9,
        ]
        : [0, 153, 255, 0.9]
    },
    createPinIcon(colorHex) {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
          <ellipse cx="16" cy="36" rx="4" ry="2" fill="rgba(0,0,0,0.2)"/>
          <path d="M16 2C10.477 2 6 6.477 6 12c0 6 10 24 10 24s10-18 10-24C26 6.477 21.523 2 16 2z" 
                fill="${colorHex}" 
                stroke="#ffffff" 
                stroke-width="2"/>
          <circle cx="16" cy="12" r="5" fill="#ffffff"/>
          <circle cx="16" cy="12" r="3" fill="${colorHex}"/>
        </svg>
      `.trim()
      return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`
    },
    buildProjectPopupContent(attributes) {
      if (attributes) {
        return `
          <b>معرف المشروع:</b> ${attributes.id || 'N/A'}<br>
          <b>الاسم:</b> ${attributes.name || 'N/A'}<br>
          <b>المالك:</b> ${attributes.owner_name || 'N/A'}<br>
          <b>الحالة:</b> ${attributes.status || 'N/A'}<br>
          <b>الكود المساحي:</b> <a href="https://alhalwany-esga.com/project-details/${attributes.id}" target="_blank" rel="noopener noreferrer">${attributes.surveying_code || 'N/A'}</a>
        `
      }
      return 'لا توجد معلومات متاحة'
    },
    buildMapLibraryPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = '<b>مكتبة خرائط</b><br>'
      if (attributes.governorate) {
        content += `<b>المحافظة:</b> ${attributes.governorate.name_ar || attributes.governorate.name || 'N/A'}<br>`
      }
      if (attributes.center) {
        content += `<b>المركز:</b> ${attributes.center.name_ar || attributes.center.name || 'N/A'}<br>`
      }
      if (attributes.city) {
        content += `<b>المدينة:</b> ${attributes.city.name_ar || attributes.city.name || 'N/A'}<br>`
      }
      if (attributes.district) {
        content += `<b>الحي:</b> ${attributes.district.name_ar || attributes.district.name || 'N/A'}<br>`
      }
      if (attributes.shape_area) {
        content += `<b>المساحة:</b> ${attributes.shape_area}<br>`
      }

      return content
    },
    buildFixedPointPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.code) {
        content += `<b>الكود:</b> ${attributes.code}<br>`
      }
      if (attributes.level !== undefined && attributes.level !== null) {
        content += `<b>المستوى:</b> ${attributes.level}<br>`
      }
      if (attributes.accuracy_degree_label_ar || attributes.accuracy_degree_label) {
        content += `<b>درجة الدقة:</b> ${attributes.accuracy_degree_label_ar || attributes.accuracy_degree_label || 'N/A'}<br>`
      }
      if (attributes.description) {
        content += `<b>الوصف:</b> ${attributes.description}<br>`
      }
      if (attributes.corrected_latitude && attributes.corrected_longitude) {
        content += `<b>الإحداثيات:</b> ${parseFloat(attributes.corrected_latitude).toFixed(6)}, ${parseFloat(attributes.corrected_longitude).toFixed(6)}<br>`
      } else if (attributes.latitude && attributes.longitude) {
        content += `<b>الإحداثيات:</b> ${parseFloat(attributes.latitude).toFixed(6)}, ${parseFloat(attributes.longitude).toFixed(6)}<br>`
      }
      if (attributes.governorate) {
        content += `<b>المحافظة:</b> ${attributes.governorate.name_ar || attributes.governorate.name || 'N/A'}<br>`
      }
      if (attributes.city) {
        content += `<b>المدينة:</b> ${attributes.city.name_ar || attributes.city.name || 'N/A'}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
  },
}
</script>

<style scoped>
.map-data-view {
  padding: 1rem;
}

.map-container-wrapper {
  position: relative;
  width: 100%;
  height: 600px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.map-view {
  width: 100%;
  height: 100%;
}

.home-location-button {
  margin-top: 4px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style>
.home-location-button--loading {
  pointer-events: none;
  opacity: 0.8;
}

.home-location-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #3498db;
  border-top-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: home-location-spin 1s linear infinite;
}

@keyframes home-location-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
